import React, { useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import ProductTicketService from '../../../../services/ProductTicketService'
import { Link } from 'react-router-dom'
import { priorityClasses, statusClasses, priorityOptions, statusOptions } from '../../../../utils/OptionUtils'
import { BsBookmarksFill } from "react-icons/bs";
import Assign from '../../../../modals/Assign'
import EditTicketModal from '../modals/EditTicketModal'

const ListProductTicket = ({ customerId, handleSubmit, control, errors, onSubmitAssign, onSubmit, usersList, tickets: initialTickets, handleColumnChange, showEditModal, setShowEditTicketModal }) => {
    const [productTickets, setProductTickets] = useState(initialTickets || []);
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [columnType, setColumnType] = useState(null);
    const [ticketId, setTicketId] = useState('');

    const fetchProductTickets = useCallback(async () => {
        try {
            const response = await ProductTicketService.getByCustomer(customerId);
            if (response.status === 200) {
                setProductTickets(response?.data?.data);
            }
        } catch (error) {
            toast.error(error?.message || 'An error occurred.');
        }
    }, [customerId]);

    useEffect(() => {
        if (customerId) {
            fetchProductTickets()
        }
        if (initialTickets) {
            setProductTickets(initialTickets)
        }

    }, [fetchProductTickets, customerId, initialTickets]);




    const columnChange = (record, type) => {
        setTicketId(record.id);
        setColumnType(type);
        setShowEditTicketModal(true);
        handleColumnChange(record, type);
    };
    const handleAssign = (id) => {
        setTicketId(id);
        setShowAssignModal(true);
    }
    const handleClose = () => {
        setShowAssignModal(false);
        setShowEditTicketModal(false);
    }
    const handleAssignSubmit = async (data) => {
        data.ticket_id = ticketId;
        onSubmitAssign(data);
        handleClose();
    }
    return (
        <>
            <table className="table table-sm table-hover table-nowrap card-table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Ticket No</th>
                        <th>Product Name</th>
                        <th>Title</th>
                        <th>Assign To</th>
                        <th>Priority</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {productTickets.length > 0 ? (
                        productTickets.map((row, index) => (
                            <tr key={`productticket-${row.id}`} data-ticket-id={row.id}>
                                <td>{index + 1}</td>
                                <td>
                                    <Link to={`/tickets/${row?.id}/basic`}>
                                        {row?.ticket_no}
                                    </Link>
                                </td>
                                <td>{row?.customerProduct?.product?.name}</td>
                                <td>{row?.title}</td>
                                <td>{row?.assignedTo?.name || 'Unassigned'}</td>
                                <td>
                                    <span
                                        className={`editable-field badge ${priorityClasses[row?.priority]}`}
                                        onClick={() => columnChange(row, 'priority')}
                                    >
                                        {row?.priority?.charAt(0).toUpperCase() + row?.priority.slice(1)}
                                    </span>
                                </td>
                                <td>
                                    <span
                                        className={`editable-field badge ${statusClasses[row?.status]}`}
                                        onClick={() => columnChange(row, 'status')}
                                    >
                                        {row?.status?.charAt(0).toUpperCase() + row?.status.slice(1)}
                                    </span>
                                </td>
                                <td>
                                    <Link to="#" onClick={() => handleAssign(row?.id)}><BsBookmarksFill title='Assign' /></Link>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="8" className='text-center'>No Tickets Available</td>
                        </tr>
                    )}
                </tbody>
            </table>
            {showAssignModal && (
                <Assign
                    show={showAssignModal}
                    handleClose={handleClose}
                    onSubmit={handleAssignSubmit}
                    handleSubmit={handleSubmit}
                    control={control}
                    errors={errors}
                    AssigneeList={usersList}
                />
            )}
            {showEditModal && (
                <EditTicketModal
                    show={showEditModal}
                    handleSubmit={handleSubmit}
                    handleClose={handleClose}
                    onSubmit={onSubmit}
                    id={ticketId}
                    control={control}
                    errors={errors}
                    options={columnType === 'priority' ? priorityOptions : statusOptions}
                    type={columnType}
                />
            )}
        </>
    )
}

export default ListProductTicket